define(
// @formatter:off
    'partials/navToggle',[
        'jquery',
        'mmc.libs.log',
        'fastclick'
    ], 
    function(
        $,
        log,
        FastClick
    ) {
// @formatter:on
    var navToggle = function(menuToggleSelector, menuSelector){
        var $menu = $(menuSelector);
        var $toggle = $(menuToggleSelector)
        
        if ($toggle.is(':visible')) {
            $toggle.click(function(){
                if ($menu.hasClass('is-open')) {
                    $menu.slideUp('fast', function(){
                        $menu.removeClass('is-open');
                    });
                } else {
                    $menu.slideDown('fast', function(){
                        $menu.addClass('is-open');
                    });
                }
            });
        }
    };

    return navToggle;
});

